import i18n from 'src/i18n';

export const localeCompare = (a: string, b: string): number => {
  const locale = i18n.language;

  return a.localeCompare(b, locale);
};
